/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import templateOnly from '@ember/component/template-only';
import { type IDisputeBalanceTransaction } from 'uplisting-frontend/models/dispute';

interface IArgs {
  transactions: IDisputeBalanceTransaction[];
}

interface UiProtectionDisputePanelBalanceTransactionsSignature {
  Element: HTMLDivElement;

  Args: IArgs;
}

const UiProtectionDisputePanelBalanceTransactionsComponent =
  templateOnly<UiProtectionDisputePanelBalanceTransactionsSignature>();

export default UiProtectionDisputePanelBalanceTransactionsComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::Protection::DisputePanel::BalanceTransactions': typeof UiProtectionDisputePanelBalanceTransactionsComponent;
    'ui/protection/dispute-panel/balance-transactions': typeof UiProtectionDisputePanelBalanceTransactionsComponent;
  }
}
